import { b as t } from "../../base-nYmjnkiN.js";
import { useMemo as p } from "react";
import "react/jsx-runtime";
import "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
function a(r) {
  const { appId: o } = t();
  return p(
    () => o === r,
    [r, o]
  );
}
export {
  a as useIsInternalForApp
};
